module.exports = __webpack_public_path__ + "static/media/grocery.c5497ec0.png";